<template>
  <b-row>
    <b-form-group label="Produto">
      <b-input-group>
        <b-form-input v-model="model" :required="required"></b-form-input>
        <b-input-group-prepend>
          <span class="p-inputgroup-addon" v-if="model">
            <img
              fluid
              :src="iconClear"
              style="height: 15px; width: 15px; cursor: pointer"
              @click="clearProduct"
            />
          </span>
        </b-input-group-prepend>
        <b-input-group-prepend>
          <span class="ml-3">
            <img
              fluid
              :src="iconSearch"
              style="height: 30px; width: 30px; cursor: pointer"
              @click="modal"
            />
          </span>
        </b-input-group-prepend>
      </b-input-group>
    </b-form-group>
  </b-row>
  <Sidebar
    v-model:visible="visible"
    position="left"
    class="p-sidebar-lg"
    style="width: 90%"
  >
    <b-form @submit="filtrar">
      <b-card class="mt-2">
        <template #header>
          <b-row class="text-end">
            <b-col class="lg-auto">
              <b-row>
                <b-col class="col-lg-auto">
                  Consulta
                  <b-badge variant="success" class="ml-2">Produtos </b-badge>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-button class="ml-2" type="submit" variant="primary">
                Filtrar
              </b-button>
            </b-col>
          </b-row>
        </template>

        <b-row>
          <b-form-group
            label="Opções de filtro"
            class="col-md-12 col-sm-6 col-lg-12"
          >
            <VueMultiselect
              mode="tags"
              v-model="inputCombo"
              :options="optionsCombo"
              noOptionsText="Nenhum resultado encontrado!"
              noResultsText="Nenhum resultado encontrado!"
              placeholder=""
              :searchable="true"
              label="desc"
              trackBy="desc"
              valueProp="id"
              value="id"
              required
            >
            </VueMultiselect>
          </b-form-group>
          <b-form-group label="" class="col-md-12 col-sm-6 col-lg-12">
            <b-form-input v-model="inputText" required></b-form-input>
          </b-form-group>
        </b-row>

        <b-row>
          <b-col class="col-md-12 col-sm-12 col-lg-7">
            <b-table
              :key="key"
              selectable
              small
              :items="produtos"
              :fields="fieldsProdutos"
              responsive
            >
              <template #cell(selected)="data">
                <b-form-checkbox
                  v-model="data.item.active"
                  @change="onChangeItemSelected(data.item, 0)"
                >
                </b-form-checkbox>
              </template>
              <template #cell(venda)="data">
                <div>{{ format(parseFloat(data.item.venda), config) }}</div>
              </template>
              <template #cell(Ações)="data">
                <b-button-group>
                  <b-button
                    class="ml-2"
                    pill
                    variant="transparent"
                    @click="onChangeProduct(data.item)"
                  >
                    <img
                      fluid
                      :src="iconCheck"
                      style="height: 30px; width: 30px; cursor: pointer"
                      @click="modal"
                    />
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
          </b-col>
          <b-col class="col-md-12 col-sm-12 col-lg-5">
            <b-table
              :key="key"
              selectable
              small
              :items="produtosEquivalencia"
              :fields="fieldsProdutosEquivalencia"
              responsive
            >
              <template #cell(selected)="data">
                <b-form-checkbox
                  v-model="data.item.active"
                  @change="onChangeItemSelected(data.item, 1)"
                >
                </b-form-checkbox>
              </template>
              <template #cell(Ações)="data">
                <b-button-group>
                  <b-button
                    class="ml-2"
                    pill
                    variant="transparent"
                    @click="onChangeProduct(data.item)"
                  >
                    <img
                      fluid
                      :src="iconCheck"
                      style="height: 30px; width: 30px; cursor: pointer"
                      @click="modal"
                    />
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card>
    </b-form>
  </Sidebar>
</template>

<script>
const optionsCombo = [
  { id: 'codfabricante', desc: 'Cód. Fabricante' },
  { id: 'codequivalente', desc: 'Equivalente' },
  { id: 'descricao', desc: 'Descrição' },
  { id: 'codigo', desc: 'Código' },
  { id: 'localizacao', desc: 'Localização' },
  { id: 'grupo', desc: 'Grupo' },
]
import service from '@/services/BaseService'
import iconSearch from '@/icons/search.png'
import iconCheck from '@/icons/check.png'
import iconClear from '@/icons/clear.png'
import { format } from 'v-money3'
import config from '@/functions/formatMoney'
export default {
  emits: ['onChangeProduct', 'onChangeDescUserProduct'],
  props: ['required', 'id', 'descricao'],
  setup() {
    return {
      iconSearch,
      iconCheck,
      iconClear,
    }
  },
  data() {
    return {
      key: 0,
      optionsCombo: optionsCombo,
      descUser: '',
      model: null,
      produtosOld: [],
      produtos: [],
      produtosEquivalenciaOld: [],
      produtosEquivalencia: [],
      inputCombo: ['codfabricante', 'codequivalente', 'descricao'],
      inputTextOld: null,
      inputText: null,
      fieldsProdutos: [
        { key: 'selected', label: '', class: 'text-center' },
        { key: 'codigo', label: 'Código' },
        { key: 'codfabricante', label: 'Cód. Fabricante' },
        { key: 'localizacao', label: 'Local' },
        { key: 'descricao', label: 'Descrição' },
        { key: 'unidade', label: 'Unidade' },
        { key: 'venda', label: 'Venda' },
        { key: 'quantlimite', label: 'Qtd Disp' },
        { key: 'Ações', label: '', class: 'text-center' },
      ],
      fieldsProdutosEquivalencia: [
        { key: 'selected', label: '', class: 'text-center' },
        { key: 'codequivalente', label: 'Cod. Equivalente' },
        { key: 'codfabricante', label: 'Cod. Fabricante' },
        { key: 'descricao', label: 'Descrição' },
        { key: 'Ações', label: '', class: 'text-center' },
      ],
      visible: false,
      format: format,
      config: config,
    }
  },
  created() {
    if (this.id && this.descricao) {
      this.model = `${this.id} - ${this.descricao}`
    }
  },
  watch: {
    model(value) {
      if (value) {
        if (value.includes('- ')) {
          this.descUser = value.split('- ')[1]
        } else {
          this.descUser = value
        }
        this.$emit('onChangeDescUserProduct', this.descUser)
      }
    },
  },
  methods: {
    setItemSelected(value) {
      if (value.active == true) {
        var produtoSelected = []
        var produtosEquivalenciaSelected = []
        this.produtos.forEach((element) => {
          if (element.id == value.id) {
            produtoSelected.push(element)
          } else {
            element.active = false
          }
        })
        this.produtosEquivalencia.forEach((element) => {
          if (element.id == value.id) {
            produtosEquivalenciaSelected.push(element)
          } else {
            element.active = false
          }
        })
        this.produtos = produtoSelected
        this.produtosEquivalencia = produtosEquivalenciaSelected
      } else {
        this.produtosOld.forEach((element) => {
          element.active = false
        })
        this.produtosEquivalenciaOld.forEach((element) => {
          element.active = false
        })
        this.produtos = this.produtosOld
        this.produtosEquivalencia = this.produtosEquivalenciaOld
      }
      this.key++
    },
    onChangeItemSelected(item, table) {
      this.setItemSelected(item)
      if (item.active == true) {
        if (table == 0) {
          this.getEquivalencia(item.codfabricante)
        } else {
          this.getProdutos(item.codfabricante)
        }
      }
    },
    modal() {
      this.visible ? (this.visible = false) : (this.visible = true)
    },
    onChangeProduct(value) {
      this.model = value.id + ' - ' + value.descricao
      this.$emit('onChangeProduct', value)
    },
    async filtrar() {
      await this.getProdutos()
      await this.getEquivalencia()
    },
    async getProdutos(text) {
      var http = new service(
        `EST_PRODUTO/search/params?limit=100&slugId=${
          this.inputCombo
        }&slugDesc=${text ? text : this.inputText}`,
      )
      await http.find().then((resp) => {
        this.produtos = resp.data.response
        if (this.produtos.length == 1) {
          this.produtos[0].active = true
        }
        this.produtos.forEach((element) => {
          element.venda = parseFloat(element.venda)
          element.qtsolicitada = parseFloat(element.qtsolicitada)
        })
        if (!text) {
          this.produtosOld = this.produtos
        }
      })
    },
    async getEquivalencia(text) {
      var http = new service(
        `EST_PRODUTO_EQUIVALENCIA/search/params?limit=100&slugId=${
          this.inputCombo
        }&slugDesc=${text ? text : this.inputText}`,
      )
      await http.find().then((resp) => {
        this.produtosEquivalencia = resp.data.response
        if (this.produtosEquivalencia.length == 1) {
          this.produtosEquivalencia[0].active = true
        }
        this.produtosEquivalencia.forEach((element) => {
          element.venda = parseFloat(element.venda)
          element.qtsolicitada = parseFloat(element.qtsolicitada)
        })
        if (!text) {
          this.produtosEquivalenciaOld = this.produtosEquivalencia
        }
      })
    },
    clearProduct() {
      this.model = null
      this.$emit('onChangeProduct')
    },
  },
}
</script>
